import * as React from 'react';
import { LayoutsState } from '../../../../store/layouts';
import SectionsContainer, { SectionsContainerProps } from './SectionsContainer';

type LayoutableSectionsContainerProps = SectionsContainerProps & { layouts: LayoutsState };
const LayoutableSectionsContainer = (props: LayoutableSectionsContainerProps) => <SectionsContainer withViewsInHeader {...props} />;
export default LayoutableSectionsContainer;
